import { create } from "zustand";

type SortConfig = { key: string; direction: "asc" | "desc" };

interface PlatScriptsState {
  totalCount: number;
  totalScripts: [];
  sortConfig: SortConfig;
  setTotalCount: (total: number) => void;
  setTotalScripts: (scripts: []) => void;
  setSortConfig: (config: SortConfig | ((prev: SortConfig) => SortConfig)) => void;
}

const platScriptsStore = create<PlatScriptsState>()((set) => ({
  totalCount: 0,
  totalScripts: [],
  sortConfig: {
    key: "created_at",
    direction: "desc",
  },
  setTotalCount: (total: number) => set({ totalCount: total }),
  setTotalScripts: (scripts: []) => set({ totalScripts: scripts }),
  setSortConfig: (config) =>
    set((state) => ({
      sortConfig: typeof config === "function" ? config(state.sortConfig) : config,
    })),
}));

export default platScriptsStore;
